export const LOCAL_SERVER_URL = 'http://localhost:8080';

type OpenApiDefinition = { info?: { title?: string } };

export async function buildPostmanCollection(
  definition: object,
  serverUrl?: string,
): Promise<object> {
  const { convertV2 } = await import('openapi-to-postmanv2');
  const spec = {
    ...definition,
    servers: [{ url: serverUrl || LOCAL_SERVER_URL }],
  };
  return new Promise((resolve, reject) =>
    convertV2(
      { type: 'json', data: spec },
      { folderStrategy: 'Tags', parametersResolution: 'Example' },
      (error, result) => {
        const collection = result?.output?.[0]?.data;
        if (error || !result?.result || !collection) {
          reject(
            new Error(error?.message || result?.reason || 'Conversion failed'),
          );
          return;
        }
        resolve(collection);
      },
    ),
  );
}

export async function exportPostmanCollection(
  definition: object,
  serverUrl?: string,
): Promise<void> {
  const collection = await buildPostmanCollection(definition, serverUrl);
  const title = (definition as OpenApiDefinition).info?.title || 'api';
  const fileName = `${title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')}.postman_collection.json`;
  const url = URL.createObjectURL(
    new Blob([JSON.stringify(collection, null, 2)], {
      type: 'application/json',
    }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url));
}
